import styled from 'styled-components';
import colors from '@/styles/colors';

export const StyledContainer = styled.section``;

export const SkillsWrapper = styled.div.attrs({
  className: 'flex lg:w-full sm:mx-auto sm:mb-2',
})`
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
// Skills Card
export const SkillsCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 1px solid rgb(67 94 125 / 90%);
  border-radius: 5px;
  margin-top: 16px;
  background: linear-gradient(${colors.black}, ${colors.dark});
  &:hover {
    box-shadow: -1px 6px 1px 0px rgb(105 105 105 / 26%), 0px 1px 1px 0px rgb(121 115 115 / 18%), 5px 4px 6px 5px rgb(169 161 161 / 28%);
  }
`;
export const SkillsCardTitle = styled.h3`
  font-weight: 400;
  font-size: 24px;
  color: ${colors.lighter};
`;
export const SkillsCardContent = styled.div`
  justify-content: space-evenly;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 10px;
  @media (max-width: 576px) {
    padding: 8px;
  }
`;
export const SkillsCardItem = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media (max-width: 1366px) {
    width: 130px;
  }
  @media (max-width: 1024px) {
    margin-bottom: 16px;
  }
  @media (max-width: 768px) {
    width: 150px;
    margin-bottom: 16px;
  }
  @media (max-width: 576px) {
    width: 100px;
    margin-bottom: 16px;
  }
`;
export const SkillsItemLabel = styled.span``;
